import React, {useState} from "react";
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    PrimaryButton,
    TextField,
} from "@fluentui/react";

interface IWorkspaceGroupDialogProps {
    isOpen: boolean;
    initialGroupName?: string;
    itemCount: number;
    onConfirm: (groupName: string | undefined) => void;
    onDismiss: () => void;
}

/** Small dialog for assigning or clearing a group on selected workspace items. */
const WorkspaceGroupDialog: React.FC<IWorkspaceGroupDialogProps> = (props) => {
    const [groupName, setGroupName] = useState<string>(props.initialGroupName ?? '');

    // Reset when opened
    React.useEffect(() => {
        if (props.isOpen) {
            setGroupName(props.initialGroupName ?? '');
        }
    }, [props.isOpen, props.initialGroupName]);

    return (
        <Dialog
            hidden={!props.isOpen}
            onDismiss={props.onDismiss}
            dialogContentProps={{
                type: DialogType.normal,
                title: 'Set Group',
                subText: `Assign the ${props.itemCount} selected item${props.itemCount !== 1 ? 's' : ''} to a group. Leave blank to remove from any group.`,
            }}
            modalProps={{ isBlocking: false }}
            minWidth={360}
        >
            <TextField
                label="Group Name"
                value={groupName}
                onChange={(_, v) => setGroupName(v ?? '')}
                placeholder="e.g. Servers, Accessories…"
                autoFocus
                onKeyDown={(e) => {
                    if (e.key === 'Enter') props.onConfirm(groupName.trim() || undefined);
                }}
            />
            <DialogFooter>
                <PrimaryButton
                    text="Apply"
                    onClick={() => props.onConfirm(groupName.trim() || undefined)}
                />
                <DefaultButton
                    text="Remove Group"
                    onClick={() => props.onConfirm(undefined)}
                />
                <DefaultButton text="Cancel" onClick={props.onDismiss} />
            </DialogFooter>
        </Dialog>
    );
};

export default WorkspaceGroupDialog;

